import React from "react";
import Modal from "react-bootstrap/Modal";
import {
  GeneralButton,
  TextAreaInput,
  DateTimePicker,
  StatusPicker,
} from "../../../components/common/inputs";
import authService from "../../../services/authService";

export default function BulkExtendExpiryModal({
  show,
  onClose,
  comment,
  setComment,
  prospectStatus,
  setProspectStatus,
  extendedDate,
  setExtendedDate,
  onSubmit,
}) {
  const { category, constants } = authService.getCurrentUser();

  const handleTextInputChange = ({ target }) => {
    setComment(target.value);
  };

  const handleChange = (e) => {
    setExtendedDate(e?.target?.value || "");
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <h4 className="modal-title">Verify</h4>
      </Modal.Header>

      <div className="modal-body">
        <StatusPicker
          name="status"
          label="Status"
          type="horizontal"
          value={prospectStatus}
          onChange={(e) => setProspectStatus(e.target.value)}
        />

        <div className="d-flex align-items-center mt-3">
          <label className="mb-0 mr-3" style={{ minWidth: 100 }}>
            Extend Upto
          </label>
          <div style={{ flex: 1 }}>
            <DateTimePicker
              name="expiry_date"
              selectedDate={extendedDate}
              onChange={handleChange}
              placeholder="Select expiry date"
              readOnly={category == constants.CATEGORY.BP}
            />
          </div>
        </div>

        <div className="mt-3">
          <TextAreaInput
            rows={4}
            label="Note"
            value={comment}
            name="comment"
            onChange={handleTextInputChange}
          />
        </div>
      </div>

      <div className="modal-footer">
        <div className="col-md-12">
          <GeneralButton onClick={onSubmit} name="Verified" />
        </div>
      </div>
    </Modal>
  );
}